import { render, staticRenderFns } from "./FactoryMessage.vue?vue&type=template&id=55aa9898&scoped=true&"
var script = {}
import style0 from "./FactoryMessage.vue?vue&type=style&index=0&id=55aa9898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aa9898",
  null
  
)

export default component.exports